import type {ShiftEndVehicleConditionCheck} from "@/src/modules/officer/types";

import {uniqueVehicleServiceRequests} from "./vehicle-service-requests";
import type {VehicleConditionCheckFormValues, VehicleFuelLevel} from "../schemas";
import type {VehicleServiceRequestId} from "../types";

/**
 * Nested `vehicle_condition_check` for `POST shift/end` (no `shift_id`, `phase`, or `worked_shift_id`).
 */
export function buildShiftEndVehicleConditionCheck(
  values: VehicleConditionCheckFormValues,
  fileUrls: string[],
): ShiftEndVehicleConditionCheck {
  const mileage =
    values.odometer_miles != null && Number.isFinite(Number(values.odometer_miles))
      ? Number(values.odometer_miles)
      : 0;
  const notes = values.notes?.trim() || null;

  return {
    company_vehicle_id: values.company_vehicle_id as number,
    fuel_level: values.fuel_level as VehicleFuelLevel,
    mileage,
    condition_notes: notes,
    service_requests: uniqueVehicleServiceRequests(
      (values.service_requests ?? []) as VehicleServiceRequestId[],
    ),
    ...(fileUrls.length > 0 ? {files: fileUrls} : {files: []}),
  };
}
